import { ApiError } from "@/api/client";

export interface PlanGate {
  required_plan: string;
  current_plan: string;
}

export function parsePlanGate(err: unknown): PlanGate | null {
  if (!(err instanceof ApiError)) return null;
  if (err.status !== 403) return null;
  try {
    const body = JSON.parse(err.body) as Record<string, unknown>;
    const detail = body.detail as Record<string, unknown> | undefined;
    if (typeof detail?.required_plan === "string" && typeof detail?.current_plan === "string") {
      return { required_plan: detail.required_plan, current_plan: detail.current_plan };
    }
  } catch {
    // body is not JSON
  }
  return null;
}

export function mapApiError(
  err: unknown,
  statusMessages: Record<number, string>,
  fallback: string,
): string {
  if (err instanceof ApiError && err.status in statusMessages) {
    return statusMessages[err.status];
  }
  return fallback;
}
